var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginOption4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key 1",
    clipPath: "url(#clip0_7602_61159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7571 0.254625L11.4137 10.5464C6.80162 9.60663 2.30325 12.6499 1.486 17.3171C0.73175 21.6256 3.57463 25.9245 7.835 26.9167C12.4497 27.9912 17.0111 25.0425 17.9509 20.4304C18.1758 19.3253 18.1758 18.186 17.9509 17.0809L19.6265 15.3589C19.7061 15.2775 19.7507 15.1681 19.7507 15.0535V12.6884C19.7507 12.4469 19.9467 12.2509 20.1882 12.2509H22.8132C23.0547 12.2509 23.2507 12.0549 23.2507 11.8134V9.18838C23.2507 8.94688 23.4467 8.75088 23.6882 8.75088H25.1819C25.2983 8.75088 25.4094 8.7045 25.4916 8.62313L28.2452 5.8695C28.4097 5.705 28.5016 5.48275 28.5016 5.25087V0.875C28.5016 0.392 28.1096 0 27.6266 0H22.3766C22.1456 0 21.9234 0.091875 21.7598 0.254625H21.7571ZM9.24988 21.875C7.8 21.875 6.62488 20.6999 6.62488 19.25C6.62488 17.8001 7.8 16.625 9.24988 16.625C10.6997 16.625 11.8749 17.8001 11.8749 19.25C11.8749 20.6999 10.6997 21.875 9.24988 21.875Z",
    fill: "#49494A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7602_61159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginOption4);
export default __webpack_public_path__ + "static/media/login-option-4.ef4d294e88593305c88241654b52903f.svg";
export { ForwardRef as ReactComponent };